"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class FBMessenger extends Parse.Object {
    constructor(attributes) {
        super('FBMessenger', attributes);
    }
    /** Integration status  */
    get status() {
        return this.get('status');
    }
    set status(value) {
        this.set('status', value);
    }
    get pageId() {
        return this.get('name');
    }
    set pageId(value) {
        this.set('name', value);
    }
    get pageName() {
        return this.get('pageName');
    }
    set pageName(value) {
        this.set('pageName', value);
    }
    get token() {
        return this.get('token');
    }
    set token(value) {
        this.set('token', value);
    }
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    // New contacts will be assigned to this team
    get defaultTeam() {
        return this.get('defaultTeam');
    }
    set defaultTeam(value) {
        this.set('defaultTeam', value);
    }
    // If the sales person name will be added in the begining of all messages sent to customers
    // Default is true
    get hasBot() {
        return this.get('hasBot');
    }
    set hasBot(value) {
        this.set('hasBot', value);
    }
    get greetingMessageEnabled() {
        return this.get('greetingMessageEnabled');
    }
    set greetingMessageEnabled(value) {
        this.set('greetingMessageEnabled', value);
    }
    get greetingMessage() {
        return this.get('greetingMessage');
    }
    set greetingMessage(value) {
        this.set('greetingMessage', value);
    }
    get afterHoursMessageEnabled() {
        return this.get('afterHoursMessageEnabled');
    }
    set afterHoursMessageEnabled(value) {
        this.set('afterHoursMessageEnabled', value);
    }
    get tradingHours() {
        return this.get('tradingHours');
    }
    set tradingHours(value) {
        this.set('tradingHours', value);
    }
    get afterHoursMessage() {
        return this.get('afterHoursMessage');
    }
    set afterHoursMessage(value) {
        this.set('afterHoursMessage', value);
    }
    get supportEmail() {
        return this.get('supportEmail');
    }
    set supportEmail(value) {
        this.set('supportEmail', value);
    }
    get errorDetail() {
        return this.get('errorDetail');
    }
    set errorDetail(value) {
        this.set('errorDetail', value);
    }
    get expiresAt() {
        return this.get('expiresAt');
    }
    set expiresAt(value) {
        this.set('expiresAt', value);
    }
}
exports.FBMessenger = FBMessenger;
Parse.Object.registerSubclass('FBMessenger', FBMessenger);
//# sourceMappingURL=FBMessenger.js.map